// utils/routeConfig.js
export const ROUTE_CONFIG = {
  HIDE_GRADIENT: [
    "/terms-and-conditions",
    "/privacy-policy",
    "/user/horses",
    "/buy",
    "/event",
    "/profile",
    "/my-orders",
    "/favorite",
    "/user/sell-saddle",
    "/user/my-saddle",
    "/user/sell-saddle/create",
    "/user/my-saddle/create",
    "/user/my-saddle/edit",
    "/user/sell-saddle/edit",
    "/partner",
    "/cart",
    "/cactus",
    "/billy-cook",
  ],

  //patterns for dynamic routes
  HIDE_GRADIENT_PATTERNS: [
    "/saddle/*", // match /saddle/any-title
    "/order/*" // match /order/any-order-id
  ]
};

export const shouldHideGradient = (pathname) => {

  if (ROUTE_CONFIG.HIDE_GRADIENT.includes(pathname)) {
    return true;
  }
  // patterns
  return ROUTE_CONFIG.HIDE_GRADIENT_PATTERNS.some(pattern => {
    const regex = new RegExp(pattern.replace('*', '.*'));
    return regex.test(pathname);
  });
};